<script setup lang="ts">
// TODO: vite-svg-loader required!
/*
vite.config.ts plugins:

svgLoader({
  svgoConfig: {
    plugins: [
      {
        name: 'preset-default',
        params: {
          overrides: {
            removeViewBox: false,
          },
        },
      }
    ]
  }
})
*/
import type { CountryCode } from "@/utils-new/countryCode";
import { computed, defineAsyncComponent } from "vue"

const props = defineProps({
  country: {
    type: String as () => CountryCode,
    required: true
  },
})
const flag = computed(() => defineAsyncComponent(() => import(`./flags/${props.country}.svg`)))
</script>

<template>
  <component :is="flag" />
</template>
